import type { ReactElement } from 'react';

const SIGNE =
  "Écart = stock WMS − stock douane, en bouteilles, depuis l'inventaire du 01/01. " +
  'Positif : le WMS compte plus de bouteilles que la douane ; négatif : il en compte moins.';
const ECART_DU_JOUR = "L'écart du jour est la variation de la journée.";

/**
 * Légende du signe de l'écart (QF-006), texte validé par le Fonctionnel.
 *
 * Les montants ne sont plus colorés par leur signe : c'est cette phrase qui
 * dit ce que veut dire « positif » et « négatif ». Version complète sur le
 * détail jour par jour, version courte sur la liste des Écarts.
 */
export function LegendeEcart({ variante }: { variante: 'complete' | 'courte' }): ReactElement {
  return (
    <p className="sous-titre legende" role="note">
      {variante === 'complete' ? `${SIGNE} ${ECART_DU_JOUR}` : SIGNE}
    </p>
  );
}
